module.exports = __webpack_public_path__ + "static/media/mystery-box.311b3fdc.png";